
<div class="container mt-1">
  <div class="card shadow-sm">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-0">Ticket Status Review</h4>
        
      </div>
      <button class="btn btn-secondary btn-sm" (click)="back()">Back</button>
    </div>
    <div class="card-body">
      <form>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Employee ID</label>
          <!-- <select class="form-select" [(ngModel)]="checkerData.employeeid" name="employeeId" (change)="Onselectempolyee()">
            <option value="">Select Employee</option>
            <option *ngFor="let emp of employeeid" [value]="emp.OD_EmployeeID">{{ emp.OD_EmployeeID }}</option>
          </select> -->
        
          <input class="form-control" [(ngModel)]="checkerData.TR_Employeeid" name="TR_Employeeid" />
        
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Requester MailId</label>
          <input class="form-control" [(ngModel)]="checkerData.TR_RequesterMailid" name="firstName" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Department</label>
          <input class="form-control" [(ngModel)]="checkerData.TR_Department" name="lastName" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Source</label>
          <input class="form-control" [(ngModel)]="checkerData.TR_Source" name="designation" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Type</label>
          <input class="form-control" [(ngModel)]="checkerData.TR_Type" name="grade" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Status</label>
          <input class="form-control" [(ngModel)]="checkerData.TR_Status" name="dateOfJoining" type="text" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Priority</label>
          <input class="form-control" [(ngModel)]="checkerData.TR_Priority" name="plant" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Subject</label>
          <input class="form-control" [(ngModel)]="checkerData.TR_subject" name="department" />
        </div>
<div class="row">
  <div class="col-md-8">
    <!-- your existing form -->
  </div>

  <div class="col-md-4 d-flex justify-content-center align-items-start">
    <img
      *ngIf="checkerData.TR_Attachment"
      [src]="'data:' + checkerData.TR_FileType + ';base64,' + checkerData.TR_Attachment"
      alt="Attachment"
      class="img-thumbnail"
      style="max-width: 200px; max-height: 200px;"
      (click)="openPreview('data:' + checkerData.TR_FileType + ';base64,' + checkerData.TR_Attachment)"
    />
  </div>
  <div class="image-popup" *ngIf="fullImage" (click)="closePreview()">
  <img [src]="fullImage" class="image-popup-content" />
</div>
</div>



        <!-- <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Requester</label>
          <input class="form-control" [(ngModel)]="checkerData.requester" name="requester" />
        </div>
        <div class="mb-3 d-flex align-items-center" *ngIf="appservice.editchecker==='rejected'">
  <label class="form-label me-3" style="width: 150px;">Comments</label>
  <textarea
  class="form-control"
  [(ngModel)]="checkerData.command"
  name="command"
  style="height: 50px;"
  placeholder="Reason">
</textarea>

</div> -->

        <div class="action-buttons d-flex justify-content-start gap-2 mt-3">
          <button *ngIf="checkerData.TR_ITcloserstatus!='OnProcess' && checkerData.TR_ITcloserstatus!='Close'" class="btn btn-approve" type="button" (click)="onApprove()" >Accept</button>
         <button
  *ngIf="checkerData.TR_ITcloserstatus !== null 
      && checkerData.TR_ITcloserstatus.trim() !== ''"
  class="btn btn-warning"
  type="button"
  (click)="Pending()">
  Close
</button>
          <button class="btn btn-decline" type="button" (click)="onDecline()" >Decline</button>
        </div>
      </form>
    </div>
  </div>
</div>
